
// GENERATED FILE - do not hand-edit. Produced by
// poc-tools/danva-schema/generateDanvaModelData.js from the real, licensed
// DANVAND 2.0.0 XSD schema package (see that script's own header comment for
// the exact scope/provenance of every field below, and DanvaModelProvider.js
// for the ModelDefinition contract this satisfies). Re-run that script against
// an updated schema package to regenerate this file - never edit it directly.
export const danvandModelDefinition = {
	"model": "Danvand",
	"version": "2.0.0",
	"objectTypes": [
		{
			"id": "Knude",
			"label": "Knude",
			"geometryTypes": [
				"Point"
			],
			"attributes": [
				{
					"name": "navn",
					"label": "Navn",
					"dataType": "string",
					"required": true,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 100
					}
				},
				{
					"name": "DatoOprettetGeometri",
					"label": "Dato oprettet (geometri)",
					"dataType": "date",
					"required": true,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoOpdateretGeometri",
					"label": "Dato opdateret (geometri)",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoFejlKonstateret",
					"label": "Dato fejl konstateret",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoDbHistorisk",
					"label": "Dato DB-historisk",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "InitialerGeometri",
					"label": "Initialer (geometri)",
					"dataType": "string",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 50
					}
				},
				{
					"name": "Terraenkote",
					"label": "Terrænkote",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"totalDigits": 10,
						"fractionDigits": 2
					}
				}
			],
			"relations": []
		},
		{
			"id": "Ledning",
			"label": "Ledning",
			"geometryTypes": [
				"LineString"
			],
			"attributes": [
				{
					"name": "Loebenr",
					"label": "Løbenummer",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoOprettetGeometri",
					"label": "Dato oprettet (geometri)",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoOpdateretGeometri",
					"label": "Dato opdateret (geometri)",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoFejlKonstateret",
					"label": "Dato fejl konstateret",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoDBhistorisk",
					"label": "Dato DB-historisk",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "InitialerGeometri",
					"label": "Initialer (geometri)",
					"dataType": "string",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 50
					}
				},
				{
					"name": "DatoOprettet",
					"label": "Dato oprettet",
					"dataType": "date",
					"required": true,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoEtableret",
					"label": "Dato etableret",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoOpdateret",
					"label": "Dato opdateret",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoStatus",
					"label": "Dato status",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "Bemaerkning",
					"label": "Bemærkning",
					"dataType": "string",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 250
					}
				},
				{
					"name": "Initialer",
					"label": "Initialer",
					"dataType": "string",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 50
					}
				},
				{
					"name": "Netberegning",
					"label": "Netberegning",
					"dataType": "boolean",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "LaegningsmetodeKode",
					"label": "Lægningsmetode",
					"dataType": "code",
					"required": false,
					"codeListId": "K_LaegningsmetodeType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "LedningTransportKode",
					"label": "Ledningstransport",
					"dataType": "code",
					"required": false,
					"codeListId": "K_LedningTransportType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "NyTilslutningKode",
					"label": "Ny tilslutning",
					"dataType": "code",
					"required": false,
					"codeListId": "K_NyTilslutningType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "StatusKode",
					"label": "Status",
					"dataType": "code",
					"required": false,
					"codeListId": "K_StatusType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "LedningFunktionKode",
					"label": "Ledningsfunktion",
					"dataType": "code",
					"required": false,
					"codeListId": "VAN_KER_K_LedningFunktionType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "LedningKategoriKode",
					"label": "Ledningskategori",
					"dataType": "code",
					"required": false,
					"codeListId": "VAN_KER_K_LedningKategoriType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "MedieKode",
					"label": "Medie",
					"dataType": "code",
					"required": false,
					"codeListId": "VAN_KER_K_MedieType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "ForbrugPaaLedning",
					"label": "Forbrug på ledning",
					"dataType": "boolean",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				}
			],
			"relations": [
				{
					"name": "Startknude",
					"relationType": "Fra",
					"targetObjectTypes": [
						"Knude"
					],
					"cardinality": "1",
					"required": true
				},
				{
					"name": "Slutknude",
					"relationType": "Til",
					"targetObjectTypes": [
						"Knude"
					],
					"cardinality": "1",
					"required": true
				},
				{
					"name": "Rør",
					"relationType": "Reference",
					"targetObjectTypes": [
						"Roer"
					],
					"cardinality": "0..1",
					"required": false
				}
			]
		},
		{
			"id": "Roer",
			"label": "Rør",
			"geometryTypes": [],
			"attributes": [
				{
					"name": "navn",
					"label": "Navn",
					"dataType": "string",
					"required": true,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoOprettet",
					"label": "Dato oprettet",
					"dataType": "date",
					"required": true,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "DatoOpdateret",
					"label": "Dato opdateret",
					"dataType": "date",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "Aktiv",
					"label": "Aktiv",
					"dataType": "boolean",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "Bemaerkning",
					"label": "Bemærkning",
					"dataType": "string",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 250
					}
				},
				{
					"name": "Initialer",
					"label": "Initialer",
					"dataType": "string",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"maxLength": 50
					}
				},
				{
					"name": "DiameterIndvendig",
					"label": "Diameter, indvendig",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"totalDigits": 10,
						"fractionDigits": 2
					}
				},
				{
					"name": "Godstykkelse",
					"label": "Godstykkelse",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"totalDigits": 10,
						"fractionDigits": 2
					}
				},
				{
					"name": "Handelsmaal",
					"label": "Handelsmål",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "Ruhed",
					"label": "Ruhed",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"totalDigits": 10,
						"fractionDigits": 2
					}
				},
				{
					"name": "Selvbaerende",
					"label": "Selvbærende",
					"dataType": "boolean",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "SdrKode",
					"label": "SDR",
					"dataType": "code",
					"required": false,
					"codeListId": "K_SdrType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "TrykklasseKode",
					"label": "Trykklasse",
					"dataType": "code",
					"required": false,
					"codeListId": "K_TrykklasseType",
					"defaultValue": null,
					"editable": true,
					"constraints": null
				},
				{
					"name": "Lydhastighed",
					"label": "Lydhastighed",
					"dataType": "number",
					"required": false,
					"codeListId": null,
					"defaultValue": null,
					"editable": true,
					"constraints": {
						"totalDigits": 10,
						"fractionDigits": 2
					}
				}
			],
			"relations": []
		}
	],
	"codeLists": {
		"K_LaegningsmetodeType": [
			{
				"code": "0",
				"label": "Ukendt"
			},
			{
				"code": "1",
				"label": "Opgravning"
			},
			{
				"code": "10",
				"label": "Strømpeforing"
			},
			{
				"code": "2",
				"label": "Styret underboring"
			},
			{
				"code": "3",
				"label": "Jordraket"
			},
			{
				"code": "4",
				"label": "Rørsprængning"
			},
			{
				"code": "6",
				"label": "Relining"
			},
			{
				"code": "7",
				"label": "Stram foring"
			}
		],
		"K_LedningTransportType": [
			{
				"code": "0",
				"label": "Ukendt"
			},
			{
				"code": "1",
				"label": "Tryk"
			},
			{
				"code": "2",
				"label": "Gravitation"
			},
			{
				"code": "3",
				"label": "Vakuum"
			}
		],
		"K_NyTilslutningType": [
			{
				"code": "0",
				"label": "Ukendt"
			},
			{
				"code": "1",
				"label": "Ingen høring"
			},
			{
				"code": "2",
				"label": "Ejer skal høres"
			},
			{
				"code": "4",
				"label": "Nye tilslutninger bør undgås"
			}
		],
		"K_StatusType": [
			{
				"code": "0",
				"label": "Ukendt"
			},
			{
				"code": "11",
				"label": "Planlagt"
			},
			{
				"code": "12",
				"label": "Anlagt"
			},
			{
				"code": "13",
				"label": "Død"
			},
			{
				"code": "2",
				"label": "I brug"
			},
			{
				"code": "3",
				"label": "Ikke i brug"
			},
			{
				"code": "4",
				"label": "Fjernet"
			}
		],
		"K_SdrType": [
			{
				"code": "0",
				"label": "Ukendt"
			},
			{
				"code": "11",
				"label": "SDR11"
			},
			{
				"code": "17",
				"label": "SDR17"
			},
			{
				"code": "26",
				"label": "SDR26"
			},
			{
				"code": "33",
				"label": "SDR33"
			},
			{
				"code": "41",
				"label": "SDR41"
			}
		],
		"K_TrykklasseType": [
			{
				"code": "0",
				"label": "Ukendt"
			},
			{
				"code": "1",
				"label": "PN 4"
			},
			{
				"code": "11",
				"label": "PN 300"
			},
			{
				"code": "17",
				"label": "PN 12.5"
			},
			{
				"code": "2",
				"label": "PN 6"
			},
			{
				"code": "3",
				"label": "PN 6.3"
			},
			{
				"code": "4",
				"label": "PN 7.5"
			},
			{
				"code": "5",
				"label": "PN 10"
			},
			{
				"code": "6",
				"label": "PN 16"
			},
			{
				"code": "7",
				"label": "PN 20"
			},
			{
				"code": "8",
				"label": "PN 25"
			},
			{
				"code": "9",
				"label": "PN 50"
			}
		],
		"VAN_KER_K_LedningFunktionType": [
			{
				"code": "0",
				"label": "Ukendt (KERNE)"
			},
			{
				"code": "26",
				"label": "Brandhanestikledning"
			},
			{
				"code": "27",
				"label": "Sprinklerstikledning"
			},
			{
				"code": "28",
				"label": "Sprinklerstikledning inkl. forbrug"
			},
			{
				"code": "29",
				"label": "Tømmeledning"
			},
			{
				"code": "51",
				"label": "Alm. Ledning (KERNE)"
			},
			{
				"code": "52",
				"label": "Overløbsledning (KERNE)"
			}
		],
		"VAN_KER_K_LedningKategoriType": [
			{
				"code": "0",
				"label": "Ukendt (KERNE)"
			},
			{
				"code": "21",
				"label": "Transportledning (KERNE)"
			},
			{
				"code": "22",
				"label": "Transmissionsledning"
			},
			{
				"code": "23",
				"label": "Distributionsledning"
			},
			{
				"code": "24",
				"label": "Hovedledning (KERNE)"
			},
			{
				"code": "25",
				"label": "Stikledning (KERNE)"
			},
			{
				"code": "26",
				"label": "Intern ledning (KERNE)"
			},
			{
				"code": "28",
				"label": "Fiktiv ledning (KERNE)"
			}
		],
		"VAN_KER_K_MedieType": [
			{
				"code": "0",
				"label": "Ukendt (KERNE)"
			},
			{
				"code": "21",
				"label": "Drikkevand"
			},
			{
				"code": "22",
				"label": "Råvand"
			},
			{
				"code": "23",
				"label": "Ufiltreret vand"
			},
			{
				"code": "24",
				"label": "Skyllevand"
			},
			{
				"code": "25",
				"label": "Slam"
			},
			{
				"code": "26",
				"label": "Sekundavand"
			},
			{
				"code": "27",
				"label": "Vandingsvand"
			},
			{
				"code": "30",
				"label": "Intet medie (KERNE)"
			},
			{
				"code": "31",
				"label": "Luft"
			}
		]
	}
};
